import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getAchievementRank = async (queries = '') => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/productivity-host/ranking?${queries}` });

  return data?.data;
};

export default getAchievementRank;
